import * as deviceDetect from "deviceDetect";
import * as modalDialog from "modalDialog";
import SignupView from "views/SignupView";

export const show = (options) => {
  const signupView = new SignupView({
    models: options.models,
  });

  options = options ?? {};

  const finalOptions = {
    // Default options
    create: true,
    headingHtml: "<h2>Let's get started!</h2>",
    view: signupView,
    minHeight: 385,
    title: "signup",
    width: deviceDetect.isSmall() ? 290 : 400, // XXX Conditional on screen size
    undoZoom: true,

    // Custom options
    ...options,

    // Override
    cancelCallback: () => {
      signupView.handleAboutToBeRemoved();
      options?.cancelCallback?.();
    },
  };

  modalDialog.show(finalOptions);
};
